import React from 'react'
import { CreditCardIcon, KeyIcon } from '@heroicons/react/24/outline'

const StatsCards = ({ plan, allApiKeys }) => {
  const isPro = plan?.name?.toLowerCase() === 'pro' || plan?.displayName?.toLowerCase() === 'pro'
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="relative group">
        {isPro && (
          <div className="absolute -inset-1 bg-gradient-to-r from-primary-500 via-emerald-500 to-primary-500 rounded-xl blur opacity-40 group-hover:opacity-60 transition duration-300 animate-pulse"></div>
        )}
        <div className={`relative p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow ${
          isPro 
            ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900' 
            : 'bg-white border border-gray-200'
        }`}>
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                isPro 
                  ? 'bg-gradient-to-r from-primary-500 to-emerald-500' 
                  : 'bg-[#df6e57]/10'
              }`}>
                <CreditCardIcon className={`h-6 w-6 ${isPro ? 'text-white' : 'text-[#df6e57]'}`} />
              </div>
            </div>
            <div className="ml-4 w-0 flex-1">
              <dl>
                <dt className={`text-sm font-medium truncate ${isPro ? 'text-slate-400' : 'text-gray-500'}`}>
                  Current Plan
                </dt>
                <dd className={`text-2xl font-bold ${isPro ? 'text-white' : 'text-gray-900'}`}>
                  {plan.displayName || 'Free'}
                </dd>
                <dd className={`text-xs ${isPro ? 'text-slate-400' : 'text-gray-500'}`}>
                  {plan.limit ? `${plan.limit.toLocaleString()} calls/month` : (plan.description || '10 calls/month')}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <KeyIcon className="h-6 w-6 text-green-600" />
            </div>
          </div>
          <div className="ml-4 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">
                Active API Keys
              </dt>
              <dd className="text-2xl font-bold text-gray-900">
                {allApiKeys.filter(key => key.status === 'active').length}
              </dd>
              <dd className="text-xs text-gray-500">
                Production ready
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsCards